// Privates local storage
const localStorageGetObject = key => JSON.parse(localStorage.getItem(key));
const localStorageSetItem = (key, value) => localStorage.setItem(key, JSON.stringify(value));
const localStorageRemoveItem = key => localStorage.removeItem(key);
const sessionStorageGetObject = key => JSON.parse(sessionStorage.getItem(key));
const sessionStorageSetItem = (key, value) => sessionStorage.setItem(key, JSON.stringify(value));
const sessionStorageRemoveItem = key => sessionStorage.removeItem(key);
// Local Storage
export const lsGetLoginProfile = () => sessionStorageGetObject('loginProfileMyAyvens');
export const lsSetLoginProfile = value => sessionStorageSetItem('loginProfileMyAyvens', value);
export const lsRemoveLoginProfile = () => {
  sessionStorageRemoveItem('loginProfileMyAyvens');
};

export const lsGetDriver = () => localStorageGetObject('driver');
export const lsSetDriver = value => localStorageSetItem('driver', value);
export const lsRemoveDriver = () => {
  localStorageRemoveItem('driver');
};

export const lsGetVehicles = () => localStorageGetObject('vehicles');
export const lsSetVehicles = value => localStorageSetItem('vehicles', value);
export const lsRemoveVehicles = () => {
  localStorageRemoveItem('vehicles');
};

export const lsGetPlateSelected = () => localStorageGetObject('plateSelected');
export const lsSetPlateSelected = value => localStorageSetItem('plateSelected', value);
export const lsRemovePlateSelected = () => {
  localStorageRemoveItem('plateSelected');
};

export const lsRemoveDataSignout = () => {
  Object.keys(localStorage).forEach(key => {
    if (key.startsWith('driver')) {
      localStorageRemoveItem(key);
    }
  });
};
